import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import styles from './Contactform.module.scss'
import { H1, H4 } from '../../../../components/UI'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@material-ui/core/Button'
import * as FormAction from './../../FormAction'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import axios from 'axios'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import PersianForm from './component/persianForm'
import EnglishForm from './component/EnglishForm'
import I18n from 'i18n-js'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		}

	},
	bottom: {
		marginTop: 16

	},
	rootButton: {
		backgroundColor: '#009CDE',
		boxShadow: '0px 4px 10px #009CDE5C',
		textTransform: 'none',
		borderRadius: 14,
		fontSize: '16px',
		fontFamily: 'Shabnam',
		width: '100%',
		marginBottom: 20,
		paddingTop: 10,
		paddingBottom: 10,
		"&:hover": {
			background: "#009CDE"
		},
		"&:disabled":{
			backgroundColor:'#F3F4F9',
			color:'#CACDD9'
		}

	}

}))

const ContactForm = (props) => {
	const classes = useStyles()
	const form = useSelector(state => state.FormReducer)
	const {
		language,
		currency,
		timezone
	} = useSelector(state => state.SettingsReducer)
	const {
		name,
		mobile,
		email,
		description,
		price
	} = useSelector(state => state.FormReducer)

	const [open, setOpen] = useState(false)

	const stripe = useStripe()
	const elements = useElements()

	const handleSubmit = async () => {
		if (currency !== 'Rial' && !!price) {
			// Block native form submission.
			if (!stripe || !elements) {
				// Stripe.js has not loaded yet. Make sure to disable
				// form submission until Stripe.js has loaded.
				return
			}

			// Get a reference to a mounted CardElement. Elements knows how
			// to find your CardElement because there can only ever be one of
			// each type of element.
			const cardElement = elements.getElement(CardElement)

			// Use your card Element with other Stripe.js APIs
			const {
				error,
				paymentMethod
			} = await stripe.createPaymentMethod({
				type: 'card',
				card: cardElement
			})

			if (error) {
				alert(error.message)

				return
			} else {
				form.stripe_id = paymentMethod.id
			}
		}

		axios.post(`https://panel.betterpro.app/api/reserve`, form, {
				headers: {
					'X-Accept-Language': language,
					'X-Currency': currency,
					'X-Timezone': timezone
				}
			})
			.then(({ data }) => {
				if (!data.success) {
					setOpen(data.message)
					return
				}

				const gateway = 'https:' + data.gateway_url.split(':')[1]

				const form = document.createElement('form')
				form.setAttribute('method', data.method)
				form.setAttribute('action', gateway)
				form.setAttribute('target', '_self')
				for (const key in data.data) {
					const hiddenField = document.createElement('input')
					hiddenField.setAttribute('name', key)
					hiddenField.setAttribute('value', data.data[key])
					form.appendChild(hiddenField)
				}
				const sbutton = document.createElement('button')
				form.appendChild(sbutton)
				document.body.appendChild(form)
				form.submit()
				document.body.removeChild(form)
			})
	}

	return (

		<Container className={styles.ContactForm} maxWidth="md">
			<div className={classes.header}>
				<H1>{I18n.t('consultant.formTitle')}</H1>
				<H4>{I18n.t('consultant.formDescription')}.</H4>
			</div>
			<div className={classes.root}>

				<Snackbar open={open} autoHideDuration={1000} onClose={() => setOpen(false)}>
					<Alert onClose={() => setOpen(false)} severity="error">
						{open}
					</Alert>
				</Snackbar>


				<ValidatorForm onSubmit={handleSubmit}>
					{
						document.getElementsByTagName('body')[0].dir === 'ltr'
						&& <EnglishForm/>
					}
					{
						document.getElementsByTagName('body')[0].dir === 'rtl'
						&& <PersianForm/>
					}

					{currency !== 'Rial' && !!price && (
						<Grid container spacing={3}>
							<Grid item xs={12} md={6} dir={'ltr'}>
								<div className={styles.BankCard}>
									<CardElement/>
								</div>
							</Grid>
						</Grid>
					)}


					<Grid container justify='center' className={classes.bottom}>
						<Grid item xs={12} md={6}>
							<Button
								type="submit"
								variant="contained"
								color="primary"
								disabled={!name || !mobile || !email}
								classes={{
									root: classes.rootButton
								}}

							>{I18n.t('consultant.paymentButton')}</Button>
						</Grid>
					</Grid>

				</ValidatorForm>

			</div>

		</Container>

	)
}

export default ContactForm
